export default {
	methods: {
		labelClass(field) {
			return {
				disabled: this.isDisabled(field),
			};
		},
		isDisabled(field) {
			return field !== true;
		},
	},
};
